import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-100/50 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-12 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div>
            <a href="/" className="font-heading text-lg font-bold text-foreground-950 tracking-tight cursor-pointer">
              pandabuy.forum
            </a>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              Your trusted hub for curated pandabuyspreadsheet collections. We aggregate the best spreadsheet finds across sneakers, streetwear, luxury-inspired items, and budget-friendly picks — all updated regularly.
            </p>
            <p className="mt-3 text-xs text-foreground-400">
              This site is an independent curation platform and is not affiliated with any marketplace directly.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">Categories</h4>
            <div className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-150 whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">Guides</h4>
            <div className="flex flex-col gap-2.5">
              <a href="/article/pandabuy-spreadsheet-ultimate-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-150 cursor-pointer">
                Beginner Guide 2026
              </a>
              <a href="/article/pandabuy-spreadsheet-sneaker-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-150 cursor-pointer">
                Sneaker Shopping Guide
              </a>
              <a href="/article/pandabuy-spreadsheet-budget-hacks" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-150 cursor-pointer">
                Budget Shopping Tips
              </a>
              <a href="/article/pandabuy-spreadsheet-ultimate-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-150 cursor-pointer">
                Spreadsheet How-To
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">Legal</h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-foreground-400">Privacy Policy</span>
              <span className="text-sm text-foreground-400">Terms of Use</span>
              <span className="text-sm text-foreground-400">Disclaimer</span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-400">
            <span>&copy; 2026 pandabuy.forum. All rights reserved.</span>
            <span className="hidden sm:inline">|</span>
            <a href="/" className="hover:text-foreground-600 transition-colors cursor-pointer">Privacy</a>
            <span className="hidden sm:inline">|</span>
            <a href="/" className="hover:text-foreground-600 transition-colors cursor-pointer">Terms</a>
          </div>
          <div className="flex items-center gap-3">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer" aria-label="External Link">
              <i className="ri-external-link-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer" aria-label="Main Site">
              <i className="ri-global-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}